import { Dynamics } from '@/services/dynamics/dynamics';
import { EEntity } from '@/services/dynamics/enums/entity.enum';
import { EParticipant } from '@/services/dynamics/enums/participant.enum';
import { getPluralEntityName } from '@/services/dynamics/helpers/get-plural-entity-name.helper';
import { ICreateChatNoteParams } from '@/services/dynamics/interfaces/api/create-chat-note.interface';
import { IParticipantEntityApi } from '@/services/dynamics/interfaces/api/participant-entity.interface';
import { logger } from '@/services/logger.service';
import { EChannelProvider } from '@/services/solgari-api/enums/channel-provider.enum';
import { SolgariApiService } from '@/services/solgari-api/solgari-api.service';
import { IEntity } from '../interfaces/entity.interface';

export const saveChatNoteEntity = async (
  id: string,
  identity: string,
  source: EChannelProvider,
  user: IEntity,
): Promise<string> => {
  const chatNote = (await Dynamics.searchChatNotes({ id }))?.[0];
  const ownerId = await Dynamics.getOwnerId();
  const email = SolgariApiService.getOwnEmail();
  const fromParty = {
    [`partyid_${EEntity.SYSTEM_USER}@odata.bind`]: `/systemusers(${ownerId})`,
    participationtypemask: EParticipant.FROM,
  };

  const parties: IParticipantEntityApi[] = user.id
    ? [
        fromParty,
        {
          [`partyid_${user.type}@odata.bind`]: `/${getPluralEntityName(user.type)}(${user.id})`,
          participationtypemask: EParticipant.TO,
        },
      ]
    : [fromParty];
  const data: ICreateChatNoteParams = {
    subject: `${source}: ${user.fullName}`,
    solgari_solgariconversationid: id,
    solgari_channelprovider: source,
    solgari_fromraw: email,
    solgari_toraw: identity,
    solgari_chat_activity_parties: parties,
  };

  if (chatNote && ownerId !== chatNote.ownerId) {
    await Dynamics.updateChatNote(chatNote.id, data);
    return chatNote.id;
  }

  if (!chatNote) {
    logger.warn(
      `[Chat Note]: chat in dynamics was not created, please check it, was created by application; chat id is: ${id}`,
    );

    const result = await Dynamics.createChatNote(data);
    return result.id;
  }

  return chatNote.id;
};
